import { Vue, Watch, Prop, Component } from 'vue-property-decorator';
import imgPreview from '../imgPreview';
import style from './style.vue';
import newDistributionSave from './newDistributionAdd';
import { IPSService } from '@/services/ipsServices';
import { noop } from '@/util';

enum IsDefault {
  UNDEFAULT, // 不是默认
  DEFAULT, // 默认
}

enum State {
  disabled, // 禁用
  enable, // 启用
  edit, // 配置中
}

export enum PolicyPattern {
  achievement, // 业绩模式
  commission, // 佣金模式
}

export enum PolicyType {
  customer, // 顾客分销
  emp, // 员工分销
  guider, // 导购分销
}

export const StateText = [
  { value: State.disabled, text: '禁用' },
  { value: State.enable, text: '启用' },
  { value: State.edit, text: '配置中' },
];

export const PolicyTypeText = [
  { value: PolicyType.customer, text: '顾客分销' },
  { value: PolicyType.emp, text: '员工分销' },
  { value: PolicyType.guider, text: '导购分销' },
];

export const PolicyPatternText = [
  {
    value: PolicyPattern.achievement,
    text: '业绩模式',
    info: '仅支持导购及员工分销，分销订单的处理模式与线下门店产生订单相同，导购及员工的分销佣金通过工资体现',
  },
  {
    value: PolicyPattern.commission,
    text: '佣金模式',
    info: '支持顾客、导购及员工分销，分销所获佣金在云店系统中直接体现，分销员可在线申请提取佣金',
  },
];

export const IsDefaultText = [
  { value: IsDefault.UNDEFAULT, text: '设为默认' },
  { value: IsDefault.DEFAULT, text: '默认' },
];

interface NewDistribution {
  policyId?: number;
  policyName?: string;
  policyType?: 0 | 1 | 2;
  policyPattern?: 0 | 1;
  tagName?: string;
  state?: 0 | 1 | 2;
  empCode?: string;
  isDefault?: 0 | 1;
  isShow?: boolean;
}

@Component({
  mixins: [style],
  components: {},
})
export default class NewDistributionConfig extends Vue {
  // 员工编号
  @Prop()
  empCode;

  // 策略列表
  data: NewDistribution[] = [];
  // 页码
  page = 1;
  // 每页数量
  pageSize = 10;
  // sgId
  @Prop()
  sgId;

  // 策略类型
  policyType = 9;
  //   总数
  total = 0;

  // modeType
  @Prop()
  modeType;

  mounted() {
    this.getData();
  }

  getData() {
    IPSService.newDistributionList({
      postParams: {
        sgId: this.sgId,
        page: this.page,
        pageSize: this.pageSize,
        openState: 9,
        policyType: 9,
      },
    }).then((response) => {
      this.data = (response.list || []).map(v => Object.assign(v, { isShow: false }));
      this.total = response.count;
    });
  }

  pageChange(val) {
    this.page = val;
    this.getData();
  }

  pageSizeChange(val) {
    this.pageSize = val;
    this.getData();
  }

  updateState(policyId, updateState) {
    IPSService.newDistributionUpdateState({
      postParams: {
        policyId,
        updateState,
      },
    }).then((response) => {
      this.getData();
    });
  }
  // 下载二维码
  async downloadQrcode(policyId) {
    let img =''
   await IPSService.distributionQrcodeExport({ postParams: { policyId } }).then((res)=>{
      img=res.qrcode
    })
    
    imgPreview.open({ title: '下载招募二维码', img, isShowDownload: true }).then(noop, noop);
  }
  onDel(policyId) {
    this.$confirm('是否删除该策略?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then((result) => {
      if (result === 'confirm') {
        IPSService.newDistributionDel({
          postParams: {
            policyId,
          },
        }).then((result) => {
          this.$message.success('删除成功');
          this.getData();
        });
      }
    });
  }

  onEdit(val, policyId, disabled, policyType, policyPattern, policyState) {
    this.$emit('config', val, policyId, disabled, policyType, policyPattern, policyState);
  }

  onAdd() {
    newDistributionSave.open({ sgId: this.sgId, modeType: this.modeType }).then((result) => {
      this.$message.success('新增策略成功');
      this.onEdit(2, result.policyId, false, result.policyType, result.policyPattern, 2);
    }, noop);
  }

  renderAction(h, val) {
    return [
      !!val.operAuthority && (
        <span class="scopeSpan" onClick={this.onEdit.bind(this, 2, val.policyId, false, val.policyType, val.policyPattern, val.state)}>
          编辑
        </span>
      ),
      !val.operAuthority && (
        <span class="scopeSpan" onClick={this.onEdit.bind(this, 2, val.policyId, true, val.policyType, val.policyPattern, val.state)}>
          查看
        </span>
      ),
      !!val.operAuthority && val.state === State.enable && (
        <span class="scopeSpan" onClick={this.downloadQrcode.bind(this, val.policyId)}>
          二维码
        </span>
      ),
      !!val.operAuthority && val.state === State.enable && (
        <span class="scopeSpan" onClick={this.updateState.bind(this, val.policyId, State.disabled)}>
          禁用
        </span>
      ),
      !!val.operAuthority && val.state === State.disabled && (
        <span class="scopeSpan" onClick={this.updateState.bind(this, val.policyId, State.enable)}>
          启用
        </span>
      ),
      !!val.operAuthority && (
        <span class="scopeSpan" onClick={this.onDel.bind(this, val.policyId)}>
          删除
        </span>
      ),
    ];
  }

  setDefault(policyId, isDefault) {
    isDefault === IsDefault.UNDEFAULT
      && IPSService.newDistributionSetDefault({
        postParams: {
          policyId,
        },
      }).then((response) => {
        this.getData();
      });
  }

  onMouseEnter(row) {
    row.isShow = true;
  }

  onMouseLeave(row) {
    row.isShow = false;
  }

  render(h) {
    return (
      <div style="height: 100%">
        <el-table data={this.data} width="100%" height="calc(100% - 51px)" tooltip-effect="light">
          <el-table-column type="selection" width="55px" align="center" fixed />
          <el-table-column type="index" label="ID" width="80px" />
          <el-table-column prop="policyId" label="策略ID" width="80px" />
          <el-table-column prop="policyName" label="策略名称" show-overflow-tooltip min-width="3" />
          <el-table-column
            prop="policyType"
            label="策略类型"
            min-width="2"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{PolicyTypeText[scope.row.policyType].text}</span>;
                },
              },
            }}
          />
          <el-table-column prop="tagName" label="角色标签" min-width="2" show-overflow-tooltip={true} />
          <el-table-column
            prop="state"
            label="状态"
            min-width="1"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{StateText[scope.row.state].text}</span>;
                },
              },
            }}
          />
          <el-table-column
            prop="isDefault"
            label="是否默认"
            min-width="2"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <div class="is-default-tag" onMouseenter={this.onMouseEnter.bind(this, scope.row)} onMouseleave={this.onMouseLeave.bind(this, scope.row)}>
                      <el-tag type={scope.row.isDefault ? '' : 'warning'} v-show={scope.row.isDefault || scope.row.isShow} onClick={this.setDefault.bind(this, scope.row.policyId, scope.row.isDefault)}>
                        {IsDefaultText[scope.row.isDefault].text}
                      </el-tag>
                    </div>
                  );
                },
              },
            }}
          />
          <el-table-column
            prop="policyName"
            label="操作"
            fixed="right"
            align="center"
            min-width="3"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return this.renderAction(h, scope.row);
                },
              },
            }}
          />
        </el-table>
        <div class="bottomWrapper">
          <el-button type="primary" onClick={this.onAdd.bind(this)}>
            追加策略
          </el-button>
          <el-pagination
            on-size-change={val => this.pageSizeChange(val)}
            on-current-change={val => this.pageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
